import { useEffect, useMemo } from 'react';
import { useConnectStore, useEnvStore } from '../../../../../store/models';
import { getCurrency } from '../../../../../utils';
import mapPlanToCard from '../../../../../components/Billing/mapPlanToCard';

// The plan flagged "Most Popular" in the Connect pricing lineup.
function isMostPopularPlan (plan) {
    return plan.code?.includes('connect-growth');
}

function usePlansBrowseViewState () {
    const connectStore = useConnectStore();
    const envStore = useEnvStore();

    // Browse-only data — fetched here (on PlansBrowseView mount) rather than
    // on ConnectPage mount, so an active-plan publisher never triggers these.
    useEffect(() => {
        connectStore.getPlanDetails();
        connectStore.browseConnectIntegrations();
        connectStore.getIntegrationDetails();
        // eslint-disable-next-line
    }, []);

    // PlansBrowseView only ever renders when the publisher has no current
    // plan, so there's no plan currency to prefer here.
    const currency = getCurrency(envStore);

    // Bridge the billing-shaped plan (flat price, bullets) into the card shape
    // PricingSection/PlanCard expect, with add-ons hidden.
    const cards = useMemo(() => {
        return (connectStore.availablePlans || []).map((plan) => ({
            ...mapPlanToCard(plan, currency, isMostPopularPlan(plan)),
            addOns: [],
        }));
        // availablePlans is a plain field; observed.availablePlans is the token that changes.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectStore.observed.availablePlans, currency]);

    return {
        plans: cards,
        loading: connectStore.observed.plansLoading,
        currency,
    };
}

export default usePlansBrowseViewState;
